import React from 'react'
import '../HomePage.css'
import Navbarr from '../components/HomePageComp/Navbar'
import Intro from '../components/HomePageComp/Intro'
import Grading from '../components/HomePageComp/Grading'
import Service from '../components/HomePageComp/Services'
import Work from '../components/HomePageComp/Work'
import Contact from '../components/HomePageComp/Contact'
const HomePage = () => {
  return (
    <div>
    <Navbarr/>
      <Intro/>
      <Grading/>
      <Work/>
      <Service/>
      <Contact/>
      <p className='text-center' >Writers Wright Grading - Elevate Your Writing. Achieve Excellence.</p>
    </div>
  )
}

export default HomePage
